import React from 'react';

export const SkillCard = ({ icon: Icon, title, skills }) => (
    <div className="bg-[#141414] border border-[#732424]/30 p-6 rounded-xl hover:border-[#d92323] transition-all duration-300 hover:shadow-[0_0_15px_rgba(217,35,35,0.15)] group h-full">
        <div className="flex items-center gap-3 mb-4">
            <div className="p-3 bg-[#d92323]/10 rounded-lg group-hover:bg-[#d92323] transition-colors duration-300">
                <Icon className="w-6 h-6 text-[#d92323] group-hover:text-white transition-colors duration-300" />
            </div>
            <h3 className="text-xl font-bold text-white">{title}</h3>
        </div>
        <div className="flex flex-wrap gap-2">
            {skills.map((skill, idx) => (
                <span
                    key={idx}
                    className="px-3 py-1 text-xs font-medium bg-[#0d0d0d] text-[#7b7b7b] border border-[#732424]/20 rounded-full group-hover:text-white group-hover:border-[#d92323]/50 transition-all duration-300"
                >
                    {skill}
                </span>
            ))}
        </div>
    </div>
);